import { SharedComponentsModule } from './shared/components/shared-components.module';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from './app.routing';
import { httpInterceptorProviders } from './core/interceptors/interceptor.provider';
import { HttpClientModule } from '@angular/common/http';
import { TranslocoLoaderModule } from './core/transloco/transloco.module';
import { SpModule } from './core/services/sp.module';
import { AuthModule } from './core/auth/auth.module';
import { FuseLoadingBarModule } from './shared/components/loading-bar/loading-bar.module';
import { FuseLoadingModule } from './core/services/loading/loading.module';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';


@NgModule({
  declarations: [AppComponent],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedComponentsModule,
    HttpClientModule,
    TranslocoLoaderModule,
    AuthModule,
    SpModule,
    FuseLoadingModule,
    FuseLoadingBarModule,
    ToastModule,
  ],
  providers: [httpInterceptorProviders, MessageService],
  bootstrap: [AppComponent],
})
export class AppModule { }
